// extracted by mini-css-extract-plugin
export default {"subtitle":"FirstTimeAuth_subtitle__e2SfL","formWrapper":"FirstTimeAuth_formWrapper__NeTQX","trailingIcon":"FirstTimeAuth_trailingIcon__RclhU","button":"FirstTimeAuth_button__T1ZCd"};